<template>
	<div class="comment-container">
		<div class="comment-header">
			<div class="comment-rating">{{ orderNumberDay }}</div>
			<div class="comment-date">{{ orderFeedbackDate }}</div>
		</div>
		<div class="comment-header align-end mt-8">
			<div class="comment-rating"><StarsRating :rating="orderFeedbackRating" /></div>
			<div class="comment-total" v-if="!withoutOrder"><span class="comment-total-head">{{ getString("total") }}</span><br><span class="comment-total-body">{{ orderValue }}</span></div>
		</div>
		<div class="comment">{{ feedbackDetails }}</div>
	</div>
</template>

<script>
import {formatDateMMDDHHmm, getLocalDateFromServer} from "@/shared/helpers/dates";
import {useAnalyticsStore, useMenuStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import StarsRating from "@/order/components/StarsRating.vue";
import {orderNumberDay} from "@/console-new/helpers/orders";

export default {
	components: {StarsRating},
	setup() {
		const analyticsStore = useAnalyticsStore();
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {analyticsStore, currencyStore, languageStore, getString: languageStore.getString}
	},
	name: "CommentCloud",
	props: {
		order: {
			type: Object,
			required: false,
			validator: (value) => {
				return !!value.feedback && !!value.feedback.details;
			},
		},
		feedback: {
			type: Object,
			required: false,
			validator: (value) => {
				return !!value.details;
			},
		},
		withoutOrder: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		orderNumberDay() {
			if(this.withoutOrder) { return this.getString('review'); }
			return orderNumberDay(this.order);
		},
		orderFeedbackDate() {
			return this.withoutOrder ? formatDateMMDDHHmm(this.feedback.date) : formatDateMMDDHHmm(this.order.feedback.date);
		},
		orderFeedbackRating() {
			return this.withoutOrder ?
				((Number(this.feedback.location_rating) + Number(this.feedback.pricing_rating) + Number(this.feedback.quality_rating) + Number(this.feedback.service_rating))/4) :
				((Number(this.order.feedback.location_rating) + Number(this.order.feedback.pricing_rating) + Number(this.order.feedback.quality_rating) + Number(this.order.feedback.service_rating))/4);
		},
		orderValue() {
			return this.withoutOrder ? 0 : this.currencyStore.readableCurrencyValue(this.order.totalFormatted, false, true, true);
		},
		feedbackDetails() {
			return this.withoutOrder ? this.feedback.details : this.order.feedback.details;
		}
	},
}
</script>

<style lang="scss" scoped>
.comment-container {
	max-width: 400px;
	background-color: var(--color-bg);
	box-shadow: inset 0 2px 3px var(--color-box-shadow-3);
	border-radius: 13px;
	padding: 8px;

	.comment-header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		.comment-total {
			text-align: right;

			.comment-total-head {
				font-size: 12px;
				font-weight: 700;
				line-height: 12px;
			}
		}

		.comment-rating, .comment-date {
			font-size: 16px;
			color: var(--color-txt-1);
		}
	}

	.comment {
		margin-top: 8px;
		font-size: 14px;
		line-height: 1.5;
		color: var(--color-txt);
		white-space: pre-wrap;
		word-wrap: break-word;

		&:before {
			content: "";
			display: inline-block;
			width: 100%;
			height: 1px;
			margin-top: 8px;
			margin-bottom: 8px;
			background-color: var(--color-border-4);
		}

	}

}
</style>